<template>
  <div class="order">
    <Loading v-if="loading" />
    <div class="order__header">
      <div>
        <p>{{ $t('order') }}</p>
        <p
          v-if="order.deliveryStatus === 'expired' && !order.deliveryTime"
          class="subtitle"
        >
          {{ $t('reservation') }}
        </p>
        <p
          v-if="order.deliveryStatus === 'expired' && order.deliveryTime"
          class="subtitle"
        >
          {{ $t('delivery') }}
        </p>
      </div>
      <img
        v-if="order.status !== 'inactive' && order.deliveryStatus"
        src="@/assets/icons/DownloadBlack.svg"
        alt=""
        @click="getCSV"
      />
    </div>
    <div v-if="order.deliveryStatus" class="order__isOrder">
      <div v-if="order.phoneNumber" class="info">
        <p>{{ $t('mobilePhone') }}</p>
        <span>{{ order.phoneNumber }}</span>
      </div>
      <div v-if="order.deliveryUserName" class="info">
        <p>{{ $t('deliveryMadeBy') }}</p>
        <span>{{ order.deliveryUserName }}</span>
      </div>
      <div class="info">
        <p>{{ $t('ssn') }}</p>
        <span>{{ getDataSSN() }}</span>
        <Button
          class="ssn_btn"
          variant="notBordered"
          :title="!showDecodedSsn ? $t('show') : ''"
          @click="showSsn"
        />
      </div>
      <div
        v-if="order.deliveryId"
        class="info delivery-id"
        :idActiveDelivery="idActiveDelivery"
        @click="openQrCode"
      >
        <p>{{ $t('kolliID') }}</p>
        <span>{{ getIds(order.deliveryId, order.additionalDeliveryIds) }}</span>
      </div>
      <div v-if="order.fulfillment_order_id" class="info">
        <p>{{ $t('fulfillment_order_id') }}</p>
        <span>{{ order.fulfillment_order_id }}</span>
      </div>
      <div v-if="order.order_id" class="info">
        <p>{{ $t('order_id') }}</p>
        <span>{{ order.order_id }}</span>
      </div>
      <div v-if="order" class="info">
        <p>{{ $t('includesDrug') }}</p>
        <span>{{ getIsDrud(order.is_drug) }}</span>
      </div>
      <div v-if="order.deliveryTime || order.deliveryUserName" class="info">
        <p>{{ $t('delivered') }}</p>
        <span>
          {{ order.deliveryUserName }} {{ dateTime(order.deliveryTime) }}
        </span>
      </div>
      <div v-if="order.deleteTime || order.deleteUserName" class="info">
        <p>{{ $t('deleted') }}</p>
        <span>{{ order.deleteUserName }} {{ dateTime(order.deleteTime) }}</span>
      </div>
      <div v-if="order.reservedUserName || order.reservedTime" class="info">
        <p>{{ $t('reserved') }}</p>
        <span>
          {{ order.reservedUserName }} {{ dateTime(order.reservedTime) }}
        </span>
      </div>
      <div v-if="order.assignedUserName || order.assignedTime" class="info">
        <p>{{ $t('assignedUserName') }}</p>
        <span>
          {{ order.assignedUserName }} {{ dateTime(order.assignedTime) }}
        </span>
      </div>
      <div v-if="order.removedUserName || order.removedTime" class="info">
        <p>{{ $t('removed') }}</p>
        <span>
          {{ order.removedUserName }} {{ dateTime(order.removedTime) }}
        </span>
      </div>
      <div v-if="order.pickupTime" class="info">
        <p>{{ $t('timePickup') }}</p>
        <span>{{ dateTime(order.pickupTime) }}</span>
      </div>
      <div v-if="order.descriptionText" class="info">
        <p>{{ $t('description') }}</p>
        <span>{{ order.descriptionText }}</span>
      </div>
      <div v-if="order.resendSMSCounter" class="info">
        <p>{{ $t('resendSMSCounter') }}</p>
        <span>{{ order.resendSMSCounter }}</span>
      </div>
      <div v-if="order.resendSMSTimestamps" class="info">
        <p>{{ $t('resendSMSTimestamps') }}</p>
        <span>{{ dateTime(isLastTime) }}</span>
      </div>
    </div>
    <div
      v-if="!order.deliveryStatus && order.status !== 'inactive'"
      class="order__noOrder"
    >
      <div class="img">
        <img src="@/assets/icons/Order.svg" alt="" />
      </div>
      <div class="title">
        <p>{{ $t('noOrderReservedYet') }}</p>
      </div>
    </div>
    <div v-if="order.status === 'inactive'" class="order__noOrder">
      <div class="img">
        <img src="@/assets/icons/Order.svg" alt="" />
      </div>
      <div class="title">
        <p>{{ $t('enableLocker') }}</p>
      </div>
    </div>
  </div>
  <div class="footer-order">
    <div
      :class="{
        'button-active': true,
        tootip:
          !activePickupBox?.info.active && order.deliveryStatus !== 'reserved'
      }"
    >
      <Button
        v-if="hideButton(order)"
        :class="{
          'order-button': true,
          'resendSMS-button': order.deliveryStatus === 'delivered'
        }"
        :variant="getVariant()"
        :title="$t(getTitle())"
        @click="getActions()"
      />
      <!-- <Button
        v-if="order.deliveryStatus === 'reserved'"
        class="printDeliveryQRCode-button"
        variant="filled"
        :title="$t('printDeliveryQRCode')"
        @click="initPrintDeliveryQRCode"
      /> -->
      <Button
        v-if="order.deliveryStatus === 'reserved'"
        class="printDeliveryQRCode-button"
        variant="filled"
        :title="$t('printDeliveryQRCode')"
        @click="initPrint"
      />
      <span
        v-if="
          !activePickupBox?.info.active && order.deliveryStatus !== 'reserved'
        "
        class="tooltiptext"
      >
        {{ $t('pickupboxIsInactive') }}
      </span>
    </div>
    <div
      :class="{
        'button-active': true,
        tootip: !activePickupBox?.info.active
      }"
    >
      <Button
        v-if="order.status !== 'inactive' && !order.deliveryStatus"
        class="assignReservation-button"
        :variant="activePickupBox?.info.active ? 'filled' : 'disabled'"
        :title="$t('assignReservation')"
        @click="assignReservation"
      />
      <span v-if="!activePickupBox?.info.active" class="tooltiptext">
        {{ $t('pickupboxIsInactive') }}
      </span>
    </div>
  </div>
  <DeleteReservation
    :show-modal="showModal"
    @close-modal="showModal = false"
    @delete-reservation-request="deleteReservationRequest"
    @destroy-reservation-request="destroyReservationRequest"
  />
  <ReserveLocker
    v-if="showModalReserveLocker"
    :show-modal-reserve-locker="showModalReserveLocker"
    :active-pickup-box="activePickupBox"
    :selected-lockers="activeLocker"
    @close-modal="showModalReserveLocker = false"
  />
  <ChooseDelivery
    :show-modal-choose-delivery="showModalChooseDelivery"
    :active-box-id="activeBoxId"
    :delivery-id="deliveryId"
    :active-locker="activeLocker"
    @close-modal="showModalChooseDelivery = false"
  />
  <ResendSMS
    :show-modal-resend-sms="showModalResendSms"
    :active-box-id="activeBoxId"
    :delivery-id="deliveryId"
    @close-modal="showModalResendSms = false"
  />
  <OpenQRCode
    :show-qr-code="showQrCode"
    :id-active-delivery="idActiveDelivery"
    :delivery-qr-code="deliveryQRCode"
    :show-only-delivery-qr-code="showOnlyDeliveryQRCode"
    :show-only-delivery-id="showOnlyDeliveryID"
    @close-modal="showQrCode = false"
  />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import moment from 'moment';

import DeleteReservation from './DeleteReservation/DeleteReservation.vue';
import ReserveLocker from '@/duplicatePages/ReserveLocker/ReserveLocker.vue';
import ChooseDelivery from './ChooseDelivery/ChooseDelivery.vue';
import ResendSMS from '@/duplicatePages/ResendSMS/ResendSMS.vue';
import OpenQRCode from '@/duplicatePages/OpenQRCode/OpenQRCode.vue';

import Loading from '@/views/Loading.vue';

import { columns } from './configs';

import { OrderData } from '@/store/modules/pharmacy/types';
import { downloadCSV } from '@/utils/downloadCSV';
import { goToPickupBox } from '@/utils/goToPickupBox';

import { getLockerId } from '@/utils/tableFunctions';
import { printSticker } from '@/utils/print';

@Options({
  name: 'Order',
  emits: [
    'deleteReservationRequest',
    'getDecodedSsn',
    'destroyReservationRequest'
  ],
  props: ['order', 'activePickupBox', 'activeLocker', 'showDecodedSsn'],
  components: {
    DeleteReservation,
    ReserveLocker,
    ChooseDelivery,
    ResendSMS,
    OpenQRCode,
    Loading
  },
  data() {
    return {
      columns: columns(this.$t),
      showModal: false,
      showModalReserveLocker: false,
      showModalChooseDelivery: false,
      showModalResendSms: false,
      openDataSsn: false,
      activeBoxId: '',
      dataSsn: '',
      deliveryId: '',
      loading: false,
      showQrCode: false,
      showOnlyDeliveryID: false,
      showOnlyDeliveryQRCode: false,
      idActiveDelivery: ''
    };
  },
  computed: {
    ...mapState('pharmacy', ['deliveryQRCode']),
    isLastTime() {
      return this.order.resendSMSTimestamps[
        this.order.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },
  methods: {
    ...mapActions('pharmacy', [
      'deleteReservation',
      'getPickupBoxesByPharmacy',
      'destroyReservation',
      'printDeliveryQRCode'
    ]),
    showSsn() {
      this.$emit('getDecodedSsn');
    },
    getDataSSN() {
      this.dataSsn = this.showDecodedSsn;

      if (this.showDecodedSsn) {
        this.dataSsn = this.showDecodedSsn.ssn;

        return this.dataSsn ? this.dataSsn : this.$t('noSsn');
      } else {
        return '************';
      }
    },
    hideButton(order: OrderData) {
      if (order.deliveryStatus === 'expired' && order.deliveryTime) {
        return false;
      } else if (
        order.status !== 'inactive' &&
        order.deliveryStatus !== 'removed'
      ) {
        return true;
      } else {
        return false;
      }
    },
    getIsDrud(value: boolean) {
      return value ? `${this.$t('yes')}` : `${this.$t('no')}`;
    },
    dateTime(value: number) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getCSV(): void {
      const data = [this.order].map((el: OrderData) => ({
        deliveryId: this.getIds(el.deliveryId, el.additionalDeliveryIds),
        deliveryMadeBy: el.deliveryMadeBy,
        phoneNumber: el.phoneNumber,
        reservedTime: this.dateTime(el.reservedTime),
        assignedTime: this.dateTime(el.assignedTime)
      }));

      const columns = [...this.columns];

      downloadCSV(data, columns, `${this.$t('order')}.csv`);
    },
    deleteThisReservation() {
      this.showModal = true;
    },
    async deleteReservationRequest() {
      this.loading = true;

      await this.deleteReservation({
        boxId: this.activePickupBox.id,
        deliveryId: this.order.deliveryId
      });

      this.showModal = false;

      const { id } = this.$route.params;

      goToPickupBox(id, this.activePickupBox.id);
      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;
    },
    async destroyReservationRequest() {
      const { id } = this.$route.params;

      const payload = {
        pharmacyId: id,
        deliveryId: this.order.deliveryId,
        pickupboxId: this.activePickupBox.id
      };

      await this.destroyReservation(payload);
      this.showModal = false;

      goToPickupBox(id, this.activePickupBox.id);
      await this.getPickupBoxesByPharmacy(id);

      this.loading = false;
    },
    reserve() {
      this.showModalReserveLocker = true;
    },
    resendSMS() {
      this.deliveryId = this.order.deliveryId;
      this.activeBoxId = this.activePickupBox.id;

      this.showModalResendSms = true;
    },
    assignReservation() {
      if (this.activePickupBox?.info.active) {
        this.activeBoxId = this.activePickupBox.id;
        this.showModalChooseDelivery = true;
      } else {
        this.showModalChooseDelivery = false;
      }
    },
    async initPrintDeliveryQRCode() {
      this.loading = true;

      await this.printDeliveryQRCode({
        boxId: this.activePickupBox.id,
        deliveryId: this.order.deliveryId
      });

      if (this.deliveryQRCode) {
        this.showQrCode = true;
        this.showOnlyDeliveryQRCode = true;
        this.showOnlyDeliveryID = false;
      }

      this.loading = false;
    },
    async initPrint() {
      this.loading = true;

      this.idActiveDelivery = this.order.deliveryId;

      await this.printDeliveryQRCode({
        boxId: this.activePickupBox.id,
        deliveryId: this.order.deliveryId
      });

      const deliveryInfo = `${this.$t('kolliID')}: ${this.idActiveDelivery}`;
      const lockerInfo = `${this.$t('locker')}: ${getLockerId(
        this.order.lockerId
      )}`;
      const phoneNumber = `${this.$t('phoneNumber')}: ${
        this.order.phoneNumber
      }`;

      printSticker(
        this.deliveryQRCode.code,
        deliveryInfo,
        lockerInfo,
        phoneNumber
      );

      this.loading = false;
    },
    getVariant() {
      if (this.order.deliveryStatus === 'expired' && !this.order.deliveryTime) {
        return 'redBorderedBackground';
      } else if (
        this.order.deliveryStatus === 'expired' &&
        this.order.deliveryTime
      ) {
        return '';
      }

      if (
        !this.activePickupBox?.info.active &&
        this.order.deliveryStatus !== 'reserved'
      ) {
        return 'disabled';
      }

      if (this.order.deliveryStatus === 'reserved') {
        return 'redBorderedBackground';
      } else if (
        !this.order.deliveryStatus ||
        this.order.status !== 'inactive' ||
        this.order.deliveryStatus === 'delivered'
      ) {
        return 'filled';
      } else {
        return '';
      }
    },
    getTitle() {
      if (
        this.order.deliveryStatus === 'reserved' ||
        (this.order.deliveryStatus === 'expired' && !this.order.deliveryTime)
      ) {
        return 'deleteReservation';
      } else if (
        !this.order.deliveryStatus &&
        this.order.status !== 'inactive'
      ) {
        return 'reserve';
      } else if (this.order.deliveryStatus === 'delivered') {
        return 'resendSMS';
      } else {
        return '';
      }
    },
    getActions() {
      if (
        !this.activePickupBox?.info.active &&
        this.order.deliveryStatus !== 'reserved'
      ) {
        return this.showModalReserveLocker === false;
      }

      if (this.order.deliveryStatus === 'reserved') {
        return this.deleteThisReservation();
      } else if (
        !this.order.deliveryStatus &&
        this.order.status !== 'inactive'
      ) {
        return this.reserve();
      } else if (this.order.deliveryStatus === 'delivered') {
        return this.resendSMS();
      } else if (
        this.order.deliveryStatus === 'expired' &&
        !this.order.deliveryTime
      ) {
        return this.deleteThisReservation();
      }
    },
    openQrCode() {
      this.idActiveDelivery = this.order.deliveryId;

      this.showQrCode = true;
      this.showOnlyDeliveryID = true;
      this.showOnlyDeliveryQRCode = false;
    }
  }
})
export default class Order extends Vue {}
</script>

<style lang="scss" scoped>
.order {
  height: 400px;
  border: 1px solid $border;
  border-radius: 8px;
  margin: 0 17px;
  overflow-y: scroll;
  .order__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 43px;
    padding: 0 17px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid $border;
    p {
      font-family: 'Ubuntu-Medium';
    }
    img {
      cursor: pointer;
    }
    .subtitle {
      font-family: 'Ubuntu-Regular';
      font-size: $twelveSize;
    }
  }
  .order__isOrder {
    margin: 14px 17px;
    .info {
      &.delivery-id {
        cursor: pointer;
      }
      margin-bottom: 24px;
      p {
        color: $label;
        font-size: $twelveSize;
        line-height: $fourteenSize;
      }
      span {
        color: $mid-grey;
        font-size: $fourteenSize;
      }
      .ssn_btn {
        width: 0;
        height: 0;
      }
    }
  }
  .order__noOrder {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding-top: 70px;
    .title {
      p {
        text-align: center;
        width: 195px;
        font-size: $fourteenSize;
        line-height: $twentyOneSize;
        font-weight: 400;
        color: $label;
      }
    }
  }
}

.footer-order {
  display: flex;
  column-gap: 17px;
  margin: 17px;
  background-color: $light-grey;
}

.button-active {
  display: flex;
  background-color: $light-grey;
  .disabled {
    width: 158px;
  }
  .resendSMS-button {
    width: 170px;
  }
  .assignReservation-button {
    width: 270px;
  }
  .printDeliveryQRCode-button {
    width: 225px;
    margin: 0 12px;
  }
}

.tootip {
  position: relative;
  display: inline-block;
  .tooltiptext {
    position: absolute;
    top: -60%;
    left: 50%;
    transform: translate(-50%, -50%);
    visibility: hidden;
    width: 150px;
    font-size: $elevenSize;
    line-height: $elevenSize;
    background: $label;
    color: $white;
    text-align: center;
    border-radius: 6px;
    padding: 5px;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: $label transparent transparent transparent;
    }
  }

  &:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
}
</style>
